import { Components, Theme } from "@mui/material";

export const MuiSkeleton: Components<Omit<Theme, "MuiSkeleton">>["MuiSkeleton"] = {
  defaultProps: {
    animation: "wave",
    variant: "rounded",
  },
  styleOverrides: {
    root: {
      transform: "unset",
      backgroundColor: "#E9EBFB55",
    },
  },
};
